<template>
	<div style="border: 1px solid #ccc;">
		<Toolbar
				style="border-bottom: 1px solid #ccc"
				:editor="editor"
				:defaultConfig="toolbarConfig"
				:mode="mode"
		/>
		<Editor
				style="height: 500px;width: 500px; overflow-y: hidden;"
				v-model="html2"
				:defaultConfig="editorConfig"
				:mode="mode"
				@onCreated="onCreated"
		/>
	</div>
	
</template>

<script>
import Vue from 'vue'
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
import { IEditorConfig } from '@wangeditor/editor'



export default Vue.extend({
  components: { Editor, Toolbar },
	props:{
		html:{
			type:String,
			default:''
		}
	},
	data() {
			return {
					editor: null,
					html2:'',
					toolbarConfig: {},
					editorConfig: { 
						placeholder: '请输入内容...',
						scroll : true
						// readOnly:true
					},
					mode: 'default', // or 'simple'
			}
    },
    methods: {
			onCreated(editor) {
				this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
			},
			upload(){
				console.log(this.html)
			},
    },
    created() {
			// this.html = '请输入内容'
    },
    beforeDestroy() {
        const editor = this.editor
        if (editor == null) return
        editor.destroy() // 组件销毁时，及时销毁编辑器
    }
})
</script>

<style src="@wangeditor/editor/dist/css/style.css">
	
</style>